module.exports = __webpack_public_path__ + "public/SiteIcons/wavingHand.png?ed754c8f";